var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',_vm._g({staticClass:"button button--corner"},_vm.$listeners),[_c('CloseSVG')],1)}
var staticRenderFns = []

export { render, staticRenderFns }